import { Paragraph, paragraphSizes } from '@va/ui/design-system';
import { ReactNode } from 'react';

type CellWithIconProps = {
  leftElement: ReactNode;
  topText: ReactNode;
  bottomText?: ReactNode;
};

export const CellWithIcon = ({ leftElement, topText, bottomText }: CellWithIconProps) => (
  <div className='flex items-center gap-2 flex-nowrap'>
    {leftElement}
    <div className='flex flex-col items-start'>
      <Paragraph className='truncate'>{topText}</Paragraph>
      <Paragraph size={paragraphSizes.tiny} colorClassName='text-gray-devil' className='truncate'>
        {bottomText}
      </Paragraph>
    </div>
  </div>
);
